import * as React from 'react';
import { MouseEventHandler } from 'react';

type CalendarHeaderProps = {
    title: string,
    goPrev: MouseEventHandler<HTMLDivElement>,
    goNext: MouseEventHandler<HTMLDivElement>,
};

export function CalendarHeader({ title, goPrev, goNext }: CalendarHeaderProps): JSX.Element {
    return (
        <div className="calendar-header">
            {goPrev && <div
                className="calendar-header__prev"
                onClick={goPrev}
            />}
            <div className="calendar-header__title">
                {title}
            </div>
            {goNext && <div
                className="calendar-header__next"
                onClick={goNext}
            />}
        </div>
    );
}